export const SkuResourcesEditorTab = Object.freeze({
	Skus: 'SkusView',
	Resources: 'ResourcesView',
});
